export default __webpack_public_path__ + "static/media/Contact-App.6e503bf5.PNG";